import React from 'react';
import { Link } from 'react-router-dom';

const TrialExpired = () => {
  return (
    <div className="min-h-screen bg-cyber-dark flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-cyber-card border border-gray-800 rounded-lg p-8 text-center">
        <div className="w-16 h-16 bg-red-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
          <svg className="w-8 h-8 text-red-400" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
          </svg>
        </div>
        <h2 className="text-2xl font-bold text-white mb-4">Trial Expired</h2>
        <p className="text-gray-400 mb-6">Your free trial has ended. Upgrade to continue using CyberGuard HQ.</p>
        <Link to="/pricing" className="block w-full px-6 py-3 bg-cyber-cyan text-cyber-darker font-semibold rounded-lg hover:bg-cyan-400 transition-colors">
          View Pricing Plans
        </Link>
      </div>
    </div>
  );
};

export default TrialExpired;